import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { history } from 'store'
import { CSS_PROPS, URLS } from 'containers/constants'

import {isEmpty} from "../../../utils";
import messages from "../messages";

const StyledCartHeader = styled.header`
    align-items: center;
    border-bottom: solid 1px lightgray;
    display: flex;
    font-size: 11px;
    font-weight: 600;
    line-height: 12px;
    padding-top: 20px;
    text-align: center;
    width: 100%;
    padding-bottom: ${(props) => (props.isCartCompleted ? "20px" : "")};
    &:after {
        content: "";
        flex: 1;
    }
`;
const ReturnToCart = styled.div`
    color: #085eb9;
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    width: 33%;
    &:hover {
        cursor: pointer;
    }
    > span {
        text-align: right;
        padding-right: 20px;
    }
`;
const Title = styled.div`
    font-size: 14px;
    margin-bottom: 20px;
    width: 100%;
`;
const TabsContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    flex-wrap: nowrap;
    align-items: flex-start;
`;
const TabItem = styled.div`
    text-align: center;
    padding: 20px 10px 15px;
    font-size: ${(props) => (props.locale === "fr" ? "11px" : "12px")};
    color: gray;
    width: 100%;

    &:hover {
        cursor: ${(props) => (props.isStepComplete ? "pointer" : "default")};
    }
    &:before {
        font-size: ${(props) => (props.isStepComplete ? "7px" : "10px")};
        font-family: "${(props) =>
            props.isStepComplete ? CSS_PROPS.fontFamily.icons : CSS_PROPS.fontFamily.openSans}";
        content: "${(props) => (props.isStepComplete ? "j" : props.currentTabNumber)}";
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background-color: grey;
        color: white;
        margin-right: 5px;
        display: inline-block;
        text-align: center;
        line-height: 15px;
    }
    &.active {
        color: #001e73;
        border-bottom: solid 2px #001e73;
        padding-bottom: 13px;

        &:before {
            background-color: #001e73;
        }
    }
`;
const Heading = styled.div`
    display: flex;
    font-size: 14px;
    &:before {
        content: "";
        width: 33%;
        display: block;
    }
    > span {
        width: 33%;
    }
`;

const Close = styled.div`
    &:before {
        content: "d";
        font-family: "bbyc-crm-covert-app-icon-fonts" !important;
    }
    width: 30%;
    text-align: right;
    cursor: pointer;
`;

export class CartHeader extends PureComponent {
    static propTypes = {
        cartItems: PropTypes.number,
        isCartReviewed: PropTypes.bool.isRequired,
        isCartCompleted: PropTypes.bool.isRequired,
        returnToCartHandler: PropTypes.func,
        closeCartHandler: PropTypes.func,
        activeCartTab: PropTypes.string,
        getRouteBasedOnTabKey: PropTypes.func,
        locale: PropTypes.string,
        updateRoute: PropTypes.func,
    };

    setTabSteps = (activeCartTab, locale, updateRoute) => {
        /* An array of react-intl translation objects */
        const cartTabs = [messages.addressLabel, messages.paymentLabel, messages.reviewLabel];
        const totalTabCount = cartTabs.length;

        const getActiveCartTabId = activeCartTab || messages.addressLabel.id;
        let isStepComplete = true; // Set all steps to true so we can update the tick to the number when step isn't complete

        return cartTabs.map((tabItem, index) => {
            const isCurrentTabActive = tabItem.id === getActiveCartTabId;
            const currentTabNumber = index + 1;
            const isStepCompleted = ((enclosedStepStatus) => enclosedStepStatus)(isStepComplete);
            /* Once a step is incomplete, isStepComplete will be set to false for all following steps */
            if (isCurrentTabActive) isStepComplete = false;
            return (
                <TabItem
                    locale={locale}
                    key={tabItem.id}
                    className={isCurrentTabActive && "active"}
                    currentTabNumber={currentTabNumber}
                    isStepComplete={isStepComplete}
                    onClick={(e) => this.handleTabClick(e, tabItem.id, isStepCompleted, updateRoute)}
                >
                    <FormattedMessage {...tabItem} />
                </TabItem>
            );
        });
    };

    handleTabClick = (e, selectedCartTabId, isStepCompleted, updateRoute) => {
        if (isStepCompleted) {
            updateRoute(URLS.CHAT, this.props.getRouteBasedOnTabKey(selectedCartTabId));
        }
    };

    render() {
        const {
            isCartReviewed,
            cartItems,
            returnToCartHandler,
            activeCartTab,
            isCartCompleted,
            closeCartHandler,
            locale,
            updateRoute,
        } = this.props;

        return (
            <StyledCartHeader isCartCompleted={isCartCompleted}>
                {isCartReviewed ? (
                    <div className="center-text">
                        <Heading>
                            <FormattedMessage {...messages.checkoutTitle} />
                            {!isCartCompleted ? (
                                <ReturnToCart onClick={() => returnToCartHandler()}>
                                    <FormattedMessage {...messages.cancelCheckout} />
                                </ReturnToCart>
                            ) : (
                                <Close onClick={closeCartHandler} />
                            )}
                        </Heading>
                        {!isCartCompleted ? (
                            <TabsContainer>{this.setTabSteps(activeCartTab, locale, updateRoute)}</TabsContainer>
                        ) : null}
                    </div>
                ) : (
                    [
                        <Title key="1">
                            <FormattedMessage {...messages.cartDetailsTitle} />
                        </Title>,
                    ]
                )}
            </StyledCartHeader>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Cart/components/CartHeader.js